import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { authInfo } from '../../actions'
import { uploadImage } from '../../lib/upload';
import Dropzone from 'react-dropzone';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import ActionButtons from '../home/ActionButtons';
import Pagination from '../../components/home/Pagination';
import _ from 'lodash';

const propTypes = {
  campaign: PropTypes.object,
  onSave: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  navigation: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  onView: PropTypes.func,
  salesChannels: PropTypes.array,
  products: PropTypes.array,
  productsMeta: PropTypes.object,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)

class EditCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        sentTo: null,
        emailSubject: null,
        emailFrom: null,
        source: null,
        template: null,
        emailReplyTo: null,
        salesChannelId: null,
      },
      products: [],
      campaign: {
        name: '',
        salesChannelId: 0,
        sentTo: '',
        emailSubject: '',
        emailFrom: '',
        emailBcc: '',
        emailHeadline: '',
        emailBody: '',
        source: '',
        template: '',
        emailReplyTo: '',
        logoImage: '',
        products: [],
        featuredProduct: 0,
        emailSubjectPromo: '',
        emailHeadlinePromo: '',
        emailBodyPromo: '',
        email2Subject: '',
        email2Headline: '',
        email2Body: '',
        email2SubjectPromo: '',
        email2HeadlinePromo: '',
        email2BodyPromo: '',
        email3Subject: '',
        email3Headline: '',
        email3Body: '',
        email3SubjectPromo: '',
        email3HeadlinePromo: '',
        email3BodyPromo: '',
        email4Subject: '',
        email4Headline: '',
        email4Body: '',
        email4SubjectPromo: '',
        email4HeadlinePromo: '',
        email4BodyPromo: '',
      },
      open: false,
      edited: false,
      viewRedirect: false,
      assignedOnly: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let campaign = nextProps.campaign;
    let products = [];
    if (nextProps.campaign.id) {
      campaign = nextProps.campaign;
      products = nextProps.products;
    }
    this.setState({ campaign, products });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const campaign = this.state.campaign;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = campaign[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleSelectChange(event, index, value, target) {
    const nextState = this.state;
    nextState.campaign[target] = value;
    nextState.edited = true;
    if (target === 'salesChannelId') {
      nextState.campaign.products = [];
      nextState.assignedOnly = false;
      this.props.getProducts(nextState.campaign);
    }
    this.setState({ nextState });
    this.setRequiredParams();
  }
  handleChange(e) {
    const { campaign } = this.state;
    if (e.target.type === 'checkbox') {
      _.set(campaign, e.target.name, e.target.checked);
    } else {
      _.set(campaign, e.target.name, e.target.value);
    }
    this.setState({
      campaign,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleUploadedImage(name,value) {
    const { campaign } = this.state;
      _.set(campaign, name, value);
    this.setState({
      campaign,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleFeaturedChange(id) {
    const { campaign } = this.state;
    campaign.featuredProduct = id;
    this.setState({
      campaign,
      edited: true,
    });
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/campaigns/view/${this.state.campaign.id}`);
    }
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/campaigns/view/${this.state.campaign.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Campaign Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this campaign?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  handleAssignProducts(productId) {
    const { campaign } = this.state;
    if (campaign.products.includes(productId)) {
      _.pull(campaign.products, productId);
    } else {
      campaign.products.push(parseInt(productId, 10));
    }
    this.setState({ campaign, edited: true });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.state.campaign.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(_.omit(this.state.campaign, ['s3Bucket', 'emailBucket']));
        break;
      default:
        this.props.onSave(_.omit(this.state.campaign, ['s3Bucket', 'emailBucket']));
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/campaigns?page=1');
  }
  handleAssignedOnly(e) {
    const nextState = this.state;
    nextState.products = this.props.products;
    nextState.assignedOnly = e.target.checked;
    if (e.target.checked) {
      nextState.products = _.filter(this.props.products, (product) => this.state.campaign.products.includes(product.id));
    }
    this.setState({ nextState });
  }
  renderProductRowsTable() {
    const getProductName = (product) => { // eslint-disable-line arrow-body-style
      let productName = product.name;
      const idArray = _.map(product.items, 'id');
      const defaultEnabled = idArray.includes(product.defaultItemId);
      if (!defaultEnabled) {
        productName = `* ${productName}`;
      }
      return (productName);
    };
    return this.state.products.map((product, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{getProductName(product)}</TableRowColumn>
        <TableRowColumn key={i}>{_.result(_.pick(_.find(product.items, { id: product.defaultItemId }), ['name']), 'name')}
        </TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDisable={() => this.handleAssignProducts(product.id)}
            disabled={!this.state.campaign.products.includes(product.id)}
          />
        </TableRowColumn>
        <TableRowColumn key={i}>
          <Checkbox
            defaultChecked={this.state.campaign.featuredProduct === product.id}
            name="featuredProduct"
            onCheck={() => this.handleFeaturedChange(product.id)}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  onDrop(file, bucket, name) {
    const { dispatch } = this.props
    console.clear();
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        this.handleChange({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        alert(`Image upload failed: ${er}`);
        return '';
      });
  }
  render() {
    const salesChannels = _.map(this.props.salesChannels, (l, i) => <MenuItem value={l.id} key={i + 1} primaryText={l.name} />);
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      textStyle: {
        marginRight: '2%',
        width: '600px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>Edit Campaign</h2>
        <div className="content">
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.state.campaign.id || ''}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.name || ''}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Logo Image"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.logoImage || ''}
            name="logoImage"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES From filestack', res);
                  const targetName = 'logoImage'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Image</p>
          </button>
          <br />
          <TextField
            floatingLabelText="Campaign Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.sentTo || ''}
            name="sentTo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.sentTo}
            errorStyle={{ color: cyan500 }}
            errorText={this.state.required.sentTo}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Email From"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailFrom || ''}
            name="emailFrom"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.emailFrom}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Email Reply To"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailReplyTo || ''}
            name="emailReplyTo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.emailReplyTo}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Email Bcc"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailBcc || ''}
            name="emailBcc"
            onChange={this.handleChange}
            style={styles.inputStyle}
          /><br />
          <SelectField
            value={this.state.campaign.salesChannelId}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'salesChannelId')} // eslint-disable-line max-len
            floatingLabelText="Sales Channel"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="salesChannelId"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={this.state.required.fulfillmentLocationId}
            errorStyle={{ color: cyan500 }}
          >
            <MenuItem value={null} key={0} primaryText={''} />
            {salesChannels}
          </SelectField>
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="Disable Triggers 2, 3 and 4"
                defaultChecked={this.state.campaign.disabled}
                name="disabled"
                onCheck={this.handleChange}
              />
            </li>
          </ul>
        </div>
        <br />
        <br />
        <h2>Trigger One</h2>
        <div className="content">
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.emailSubject !== null) ? this.state.campaign.emailSubject : ''}
                name="emailSubject"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.emailHeadline !== null) ? this.state.campaign.emailHeadline : ''}
                name="emailHeadline"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.emailBody !== null) ? this.state.campaign.emailBody : ''}
                name="emailBody"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.emailSubjectPromo !== null) ? this.state.campaign.emailSubjectPromo : ''}
                name="emailSubjectPromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.emailHeadlinePromo !== null) ? this.state.campaign.emailHeadlinePromo : ''}
                name="emailHeadlinePromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.emailBodyPromo !== null) ? this.state.campaign.emailBodyPromo : ''}
                name="emailBodyPromo"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
        </div>
        <br />
        <h2>Trigger Two</h2>
        <div className="content">
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email2Subject !== null) ? this.state.campaign.email2Subject : ''}
                name="email2Subject"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email2Headline !== null) ? this.state.campaign.email2Headline : ''}
                name="email2Headline"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email2Body !== null) ? this.state.campaign.email2Body : ''}
                name="email2Body"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email2SubjectPromo !== null) ? this.state.campaign.email2SubjectPromo : ''}
                name="email2SubjectPromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email2HeadlinePromo !== null) ? this.state.campaign.email2HeadlinePromo : ''}
                name="email2HeadlinePromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email2BodyPromo !== null) ? this.state.campaign.email2BodyPromo : ''}
                name="email2BodyPromo"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
          <br />
        </div>
        <h2>Trigger Three</h2>
        <div className="content">
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email3Subject !== null) ? this.state.campaign.email3Subject : ''}
                name="email3Subject"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email3Headline !== null) ? this.state.campaign.email3Headline : ''}
                name="email3Headline"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email3Body !== null) ? this.state.campaign.email3Body : ''}
                name="email3Body"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email3SubjectPromo !== null) ? this.state.campaign.email3SubjectPromo : ''}
                name="email3SubjectPromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email3HeadlinePromo !== null) ? this.state.campaign.email3HeadlinePromo : ''}
                name="email3HeadlinePromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email3BodyPromo !== null) ? this.state.campaign.email3BodyPromo : ''}
                name="email3BodyPromo"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div><br />
        </div>
        <h2>Trigger Four</h2>
        <div className="content">
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email4Subject !== null) ? this.state.campaign.email4Subject : ''}
                name="email4Subject"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email4Headline !== null) ? this.state.campaign.email4Headline : ''}
                name="email4Headline"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email4Body !== null) ? this.state.campaign.email4Body : ''}
                name="email4Body"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <TextField
                floatingLabelText="Email Subject Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email4SubjectPromo !== null) ? this.state.campaign.email4SubjectPromo : ''}
                name="email4SubjectPromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                errorText={this.state.required.emailSubject}
                errorStyle={{ color: cyan500 }}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Headline Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email4HeadlinePromo !== null) ? this.state.campaign.email4HeadlinePromo : ''}
                name="email4HeadlinePromo"
                onChange={this.handleChange}
                style={styles.inputStyle}
                multiLine
              />
            </div>
            <div className="col">
              <TextField
                floatingLabelText="Email Body Promo"
                floatingLabelStyle={styles.floatingLabelStyle}
                value={(this.state.campaign.email4BodyPromo !== null) ? this.state.campaign.email4BodyPromo : ''}
                name="email4BodyPromo"
                multiLine
                rows={3}
                onChange={this.handleChange}
                style={styles.textStyle}
              />
            </div>
          </div>
          <br />
        </div>
        <h2>Campaign Products</h2>
        <div className="content">
          <div>
            <Checkbox
              style={{ float: 'left', width: '40%' }}
              label="View Active Products Only"
              defaultChecked={this.state.assignedOnly}
              name="assignedOnly"
              onCheck={this.handleAssignedOnly}
            />
            <div className="action-buttons top">
              <Pagination
                paginationInfo={this.props.productsMeta}
                pageCall={route => this.props.navigation(route)}
                pageName={`/campaigns/${_.get(this, 'props.campaign.id')}`}
              />
            </div>
          </div>
          <Table
            wrapperStyle={{ overflow: 'inherit' }}
            selectable={tableStyles.selectable}
            multiSelectable={tableStyles.multiSelectable}
          >
            <TableHeader
              displaySelectAll={tableStyles.displaySelectAll}
              adjustForCheckbox={tableStyles.adjustForCheckbox}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn>Product Name</TableHeaderColumn>
                <TableHeaderColumn>Default Item</TableHeaderColumn>
                <TableHeaderColumn style={{ textAlign: 'center' }}>Active</TableHeaderColumn>
                <TableHeaderColumn>Featured Product</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderProductRowsTable()}
            </TableBody>
          </Table>
        </div>
        <div className="action-buttons bottom">
          <Pagination
            style={{ marginRight: '25px' }}
            paginationInfo={this.props.productsMeta}
            pageCall={route => this.props.navigation(route)}
            pageName={`/campaigns/${_.get(this, 'props.campaign.id')}`}
          />
        </div>
        <span style={{ marginLeft: '100px' }}>* The default item for this product is not enabled.</span>
      </div>
    );
  }
}

EditCampaign.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditCampaign.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    campaign: state.campaigns.campaign,
    products: state.products.results,
    salesChannels: state.salesChannels.results,
  };
}

export default connect(mapStateToProps)(EditCampaign);



// WEBPACK FOOTER //
// ./src/components/campaigns/EditCampaign.js